/* Funções de formatação das colunas do grid */
export const validationsColumnsGrid = {

    // Função para formatar uma data do formato ISO 8601 para o formato DD-MM-AAAA
    dateFormatter(params, locale) {

      const dateValue = params.value;
      if( dateValue === null || dateValue === undefined) {
        return '';
      }

      const dateObj = new Date(dateValue);
      const formattedDate = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        timeZone: 'UTC'
      }).format(dateObj);

      return formattedDate;
    },

    // Função para formatar uma data do formato ISO 8601 para o formato DD-MM-AAAA HH:MM:SS
    dateTimeFormatter(params, locale) {

      const dateValue = params.value;
      const dateObj = new Date(dateValue);

      const formattedDateTime = new Intl.DateTimeFormat(locale, {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
        hour: 'numeric',
        minute: 'numeric',
        second: 'numeric',
        //hour12: false
      }).format(dateObj); 

      return formattedDateTime;
    },

    // Função para formatar uma data no formato ISO 8601 
    dateTimeIsoFormatter(fieldName) {

      let currentDate = new Date();
      let adjustedDate = new Date(currentDate.valueOf() - currentDate.getTimezoneOffset() * 60000);
      let isoDateTime = adjustedDate.toISOString().replace(/\.\d{3}Z$/, '');

      this[fieldName] = isoDateTime;
      return isoDateTime;
    },

    // Função para formatar uma data no formato yyyy-mm-dd para o formato ISO 8601:
    fieldDateTimeIsoFormatter(dateString) {

      if(!dateString) {
        return  null;
      }

      const parts = dateString.split('-');
      const year = parseInt(parts[0], 10);
      const month = parseInt(parts[1], 10) - 1;
      const day = parseInt(parts[2], 10);

      let date = new Date(year, month, day);
      let adjustedDate = new Date(date.valueOf() - date.getTimezoneOffset() * 60000);
      let isoDateTime = adjustedDate.toISOString().replace(/\.\d{3}Z$/, '');

      return isoDateTime;
    },

    //Função para formatar uma data no formato dd-mm-yyyy para o formato yyyy-mm-dd
    formatDateToYYYYMMDD(dateString, locale) {
      if (!dateString) {
        return null;
      }
    
      const parts = dateString.split('/');
    
      if (parts.length !== 3) {
        return null;
      }
    
      let dia, mes, ano;
    
      if (locale === "en-US") {
        // Formato MM/DD/YYYY
        mes = parts[0];
        dia = parts[1];
        ano = parts[2];
      } else {
        // Formato DD/MM/YYYY (Padrão)
        dia = parts[0];
        mes = parts[1];
        ano = parts[2];
      }
  
      return `${ano}-${mes.padStart(2, '0')}-${dia.padStart(2, '0')}`;
    },
    

    /* Função para formatar um numero com 2 casas decimais de acordo com o locale*/  
    currencyFormatter(value, locale) {
     
      if( value === null || value === undefined) {
        return '';
      }

      const formatter = new Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2,
      });

      let formattedNumber = formatter.format(value);
      return formattedNumber;
    },
    
    /* Função para formatar um numero com 4 casas decimais de acordo com o locale*/  
    currencyFormatterFourDecimals(value, locale) {
      
      if (value !== null && value !== undefined) {
        value = value.toString();
        value = value.replace(',', '.');
      } else {
        value = ''; 
      }
      
      const valorValue = parseFloat(value);

      if (!isNaN(valorValue)) {
        const formattedValue = new Intl.NumberFormat(locale, {
          minimumFractionDigits: 4,  
          maximumFractionDigits: 4 
        }).format(valorValue);

        return formattedValue;
      }
      return '';
    },

    /* Função para formatar um número com 2 casas decimais. Se for inteiro, remove as casas decimais. */  
    currencyFormatterIntlNumber(value, locale) {
      
      if (value === null || value === undefined) {
        return '';
      }
    
      const isInteger = Number.isInteger(value);
    
      const formatter = new Intl.NumberFormat(locale, {
        style: 'decimal',
        minimumFractionDigits: isInteger ? 0 : 2, 
        maximumFractionDigits: 2, 
      });
    
      let formattedNumber = formatter.format(value);
      return formattedNumber;
    },
    
    
};

export default validationsColumnsGrid;
